<template>
  <div id="app">
    <nav id="navbar">
      <Navbar/>
	  </nav>

    <section id="info-content">
      <HelloWorld/>
      <ParticlesJS/>
    </section>

    <section id="time-section">
      <TheTimeline/>
    </section>

    <section id="desc-section">
      <Description/>
    </section>

    <section id="objs-section">
      <Objectives/>
    </section>

    <section id="proc-section">
      <TheProcess/>
    </section>

    
    <section id="final-content">
      <Team/>
    </section>

  </div>
</template>

<script>
import Navbar from './components/Navbar'
import ParticlesJS from './components/Particles'
import HelloWorld  from './components/HelloWorld'
import Description from './components/Description'
import Objectives from './components/Goals'
import TheTimeline from './components/TheTimeline'
import TheProcess from './components/TheProcess'
import Team from './components/Team'


 $(window).scroll(function () {
  if ($(window).scrollTop() > $('#desc-section').position().top ) {
    $('#navbar').css('position', 'fixed');
  }

  if ($(window).scrollTop() < $('#desc-section').position().top ) {
    $('#navbar').css('position', 'absolute');
  }
});


export default {
  name: 'App',
  components: {
    Navbar,
    ParticlesJS,
	  HelloWorld,
    Description,
	  Objectives,
    TheTimeline,
	  TheProcess,
	  Team,
  }
}
</script>

<style>
html, body{
  width: 100%;
  height: 100%;
  margin: 0px;
}
section{
  padding: 0px;
  margin: 0px;
}
h1, h2{
  font-weight: normal;
  margin: auto;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
#navbar{
  background-color: #2c3e50;
  position: absolute;
  z-index: 10;
  width: 100%;
}
#info-content{
  height: 100%;
  min-height: 768px;
  padding: 0px 10% 0 10%;
}
#desc-section{
  height: 100%;
  min-height: 960px;
  padding: 0px 10% 0 10%;
  background: linear-gradient(180deg,#0b1623,#102032);
}
#objs-section{
  height: 100%;
  min-height: 960px;
  padding: unset;
  background: #102032;
}
#time-section{
  height: 100%;
  min-height: 960px;
  padding: unset;
  background: #0b1623;
}
#proc-section{
  height: 100%;
  min-height: 960px;
  padding: unset;
  background: #2d598b;
}
#final-content{
  height: 100%;
  min-height: 996px;
  padding: unset;
  background: linear-gradient(180deg,#102032,#2d598b);
}

.main-cont{
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  background-color: transparent;
  color: white;
  min-height: 100%;
}
.header-desc{
 text-transform: uppercase;
 font-size: 28px;
 color:skyblue;
 padding: 5px;
}

@media screen and (min-width: 820px) and (max-width: 1500px){
  #final-content{
    min-height: 1366px;
  }
}

@media screen and (min-width: 480px) and (max-width: 820px){
  #info-content{
    padding: unset;
  }
  #desc-section{
    min-height: 960px;
    padding: unset;
  }
  #objs-section{
    min-height: 960px;
    padding: unset;
  }
  #regs-section{
    min-height: 1280px;
    padding: unset;
  }
  #proc-section{
    min-height: 1280px;
    padding: unset;
  }
  #final-content{
    min-height: 1800px;
    padding: unset;
  }
  .header-desc{
    text-transform: uppercase;
    font-size: 24px;
    color:skyblue;
    padding: 5px;
  }
}
@media only screen and (max-width: 480px){
  #info-content{
    padding: unset;
  }
  #desc-section{
    min-height: 820px;
    padding: unset;
  }
  #objs-section{
    min-height: 920px;
    padding: unset;
  }
  #regs-section{
    min-height: 1366px;
    padding: unset;
  } 
  #proc-section{
    min-height: 1280px;
    padding: unset;
  } 
  #final-content{
    min-height: 2550px;
    padding: unset;
  }
  .header-desc{
    text-transform: uppercase;
    font-size: 20px;
    color:skyblue;
    padding: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue